<template>
  <div>
    <Swper></Swper>
    <Service></Service>
    <Cooperation></Cooperation>
    <Major></Major>
    <Partner></Partner>
    <News></News>
    <Link></Link>
  </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
import Swper from "@/components/technology/swper";
import Service from "@/components/technology/service";
import Cooperation from "@/components/technology/cooperation";
import Major from "@/components/technology/major";
import Partner from "@/components/technology/partner";
import News from "@/components/technology/news";
import Link from "@/components/technology/link";

export default {
  name: "Technology",
  components: { Header,Footer,Swper, Service,Cooperation,Major,Partner,News,Link }
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/technology/index.vue